"use strict";
import s from "underscore.string";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import Account from "../api/account";
import DashboardReturnParams from "./ui/dashboard_return_params";
import DataStoreService from "../accounts_payable/data_store_service";
import { Link } from "react-router";
import get from "./data/get";
function account() {
  return Account.current();
}
function placeholder() {
  return Account.matchAccountType({
    broker: () => "load id or reference",
    factor: () => "load id or reference",
    forwarder: () => "job id or reference"
  });
}
function loadIdLabel() {
  return Account.matchAccountType({
    broker: () => "Load Id",
    factor: () => "Load Id",
    forwarder: () => "Job Id"
  });
}
function carrierName(loadState) {
  if (loadState.load.carrier) {
    return loadState.load.carrier.name;
  }
}
function searchEndpoint() {
  if (Account.hasRole("Factor")) {
    return "/api/load_searches/factor_quick_search";
  }
  return "/api/load_searches/by_location";
}
function loadStateUrl(load_or_load_state) {
  if (Account.useSubmissionWorkflow() && load_or_load_state.email_ids[0]) {
    return `/client_submission/email/${load_or_load_state.email_ids[0]}/invoice/${load_or_load_state.factor_invoice_ids[0]}`;
  }
  if (Account.hasRole("Factor")) {
    return `/factor_invoices/${load_or_load_state.factor_invoice_ids[0]}`;
  }
  return `/loads/${load_or_load_state.id}`;
}
function formattedLocation(load, type) {
  const city = load[type + "_city"];
  const state = load[type + "_state"];
  const postalCode = load[type + "_postal_code"];
  if (s.isBlank(city) && s.isBlank(state)) {
    return load[type + "_name"];
  }
  const cityState = [];
  const cityStateAndPostalCode = [];
  if (!s.isBlank(city)) {
    cityState.push(city);
  }
  if (!s.isBlank(state)) {
    cityState.push(state);
  }
  if (cityState.length > 0) {
    cityStateAndPostalCode.push(cityState.join(", "));
  }
  if (!s.isBlank(postalCode)) {
    cityStateAndPostalCode.push(postalCode);
  }
  return cityStateAndPostalCode.join(" ");
}
function searching(state) {
  if (state.searching) {
    return /* @__PURE__ */ React.createElement("span", { className: "load-quick-search__processing-spinner" }, /* @__PURE__ */ React.createElement("img", { src: "data:image/gif;base64,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" }));
  }
}
function shipments(state) {
  const shipmentsByLoadStateId = {};
  let showShipments = false;
  state.results.forEach((load_state) => {
    const shipmentsForLoad2 = get.tmsShipments(load_state.load);
    shipmentsByLoadStateId[load_state.id] = shipmentsForLoad2;
    showShipments || (showShipments = shipmentsForLoad2 && shipmentsForLoad2.length > 0);
  });
  return {
    shipmentsByLoadStateId,
    showShipments
  };
}
function shipmentsForLoad(state, load_state, shipmentsData) {
  if (!shipmentsData.showShipments) {
    return;
  }
  const prioritizedShipments = _.sortBy(
    shipmentsData.shipmentsByLoadStateId[load_state.id] || [],
    (x) => x.external_id.toLowerCase().indexOf((state.terms || "").toLowerCase()) < 0
  );
  const limit = prioritizedShipments.length > 3;
  const remaining = prioritizedShipments.length - 2;
  const shipmentsToShow = limit ? prioritizedShipments.slice(0, 2) : prioritizedShipments;
  return /* @__PURE__ */ React.createElement("td", null, shipmentsToShow.map((shipment) => /* @__PURE__ */ React.createElement("div", { key: shipment.id }, shipment.external_id)), limit ? /* @__PURE__ */ React.createElement("div", null, "plus ", remaining, " more") : null);
}
const LoadQuickSearch = React.createClass({
  getInitialState: function() {
    return {
      results: [],
      showResults: false,
      searching: false
    };
  },
  componentDidUpdate: function(prevProps, prevState) {
    if (!_.isUndefined(prevState.terms) && prevState.terms.length > 0 && prevState.terms !== this.state.terms) {
      this.hideResults();
    }
  },
  rowChanged: function(item) {
    this.props.loadClicked(item);
    this.forceUpdate();
  },
  search: function(e) {
    e.preventDefault();
    this.hideResults();
    this.setState({ searching: true });
    const terms = this.state.terms;
    $.get(searchEndpoint(), { reference: terms }).then((data) => {
      DataStoreService.responseHandler(data);
      this.setState({
        results: data.loads,
        showResults: true,
        searching: false
      });
    });
  },
  render: function() {
    const showSearch = !account() ? false : Account.matchAccountType({
      broker: () => true,
      factor: () => true,
      forwarder: () => false
    });
    if (showSearch) {
      return /* @__PURE__ */ React.createElement("form", { "data-component": "LoadQuickSearch", onSubmit: this.search }, /* @__PURE__ */ React.createElement("div", { className: "row collapse load-quick-search__container" }, /* @__PURE__ */ React.createElement("div", { className: "large-6 small-7 columns load-quick-search__input-wrapper" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "load-quick-search__input",
          value: this.state.terms || "",
          onChange: (e) => this.setState({ terms: e.target.value }),
          type: "text",
          placeholder: placeholder(),
          onFocus: this.hideResults
        }
      ), searching(this.state)), /* @__PURE__ */ React.createElement("div", { className: "large-4 small-3 columns load-quick-search__btn-wrapper" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "submit",
          className: "load-quick-search__button button postfix load-quick-search__btn",
          value: "Search"
        }
      )), this.searchResults()));
    }
    return /* @__PURE__ */ React.createElement("span", null);
  },
  hideResults: function() {
    this.setState({ showResults: false });
  },
  cancelSearch: function() {
    this.hideResults();
    this.setState({ results: [], terms: "" });
  },
  searchResults: function() {
    if (this.state.showResults) {
      let results;
      const shipmentsData = shipments(this.state);
      if (this.state.results.length > 0) {
        results = this.state.results.map((load_state) => {
          let loadId;
          if (s.isBlank(load_state.load.load_id)) {
            loadId = `(No ${loadIdLabel()})`;
          } else {
            loadId = load_state.load.load_id;
          }
          return /* @__PURE__ */ React.createElement("tr", { key: load_state.id }, /* @__PURE__ */ React.createElement("td", { className: "load-quick-search__reference" }, /* @__PURE__ */ React.createElement(
            Link,
            {
              to: loadStateUrl(load_state),
              query: DashboardReturnParams(this.props.location)
            },
            loadId
          )), shipmentsForLoad(this.state, load_state, shipmentsData), /* @__PURE__ */ React.createElement("td", null, load_state.invoice_number), /* @__PURE__ */ React.createElement("td", null, carrierName(load_state)), /* @__PURE__ */ React.createElement("td", null, formattedLocation(load_state.load, "origin")), /* @__PURE__ */ React.createElement("td", null, formattedLocation(load_state.load, "destination")));
        });
      } else {
        results = /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 4 }, /* @__PURE__ */ React.createElement("div", { "data-alert": true, className: "alert-box warning" }, "Your search \u2013 ", /* @__PURE__ */ React.createElement("strong", null, this.state.terms), " \u2013 did not match any loads.")));
      }
      const shipmentIdHeader = shipmentsData.showShipments ? /* @__PURE__ */ React.createElement("th", null, "Shipment Id") : null;
      return /* @__PURE__ */ React.createElement("div", { className: "load-quick-search__results" }, /* @__PURE__ */ React.createElement("table", null, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, loadIdLabel()), shipmentIdHeader, /* @__PURE__ */ React.createElement("th", null, "Invoice Number"), /* @__PURE__ */ React.createElement("th", null, Account.carrierTerm()), /* @__PURE__ */ React.createElement("th", null, "Origin"), /* @__PURE__ */ React.createElement("th", null, "Destination", /* @__PURE__ */ React.createElement("a", { className: "close", onClick: this.cancelSearch }, "\xD7")))), /* @__PURE__ */ React.createElement("tbody", null, results)));
    }
  }
});
export default LoadQuickSearch;
